import React, { useState , useEffect } from "react";
import axios from "axios";

import { useUser } from "../../state/reactquery";


import './EcranDev2.scss' ;

function EcranDev2(){
    const [isRecording, setIsRecording] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioBlob, setAudioBlob] = useState(null);
    const [audioStream, setAudioStream] = useState(null);
    const {data: user} = useUser(localStorage.getItem('token'))  ;


// PARTIE ENREGISTRER ET ENVOI DE FICHIER

    const envoifichier = async ()=>{

        mediaRecorder?.stop();
        setIsRecording(false);
        const formData = new FormData();
        formData.append("audio", audioBlob, "recording.webm");
       await axios.post("dev/essai", formData, {headers: { "Content-Type": "multipart/form-data" }});
    }

    const enregistrer = async()=>{
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const recorder = new MediaRecorder(stream);
        const chunks = [];

        recorder.ondataavailable = (event) => {chunks.push(event.data); };

        recorder.onstop = () => {
          const blob = new Blob(chunks, { type: "audio/webm" });
          setAudioBlob(blob);
          stream.getTracks().forEach((track) => track.stop());
          setAudioStream(null);
        };

        recorder.start();
        setMediaRecorder(recorder);
        setAudioStream(stream);
        setIsRecording(true);
    }
  
    const handleButtonClick = async () => {
      if (!isRecording) {await enregistrer() ;   
      } else {await  envoifichier()}
    };

    const findmails =async ()=>{
      const toto =  await axios({method:'POST',url :`/googleapis/myemails`,data:{"email" :user.email}  ,headers:{'Accept':'application/json','Content-Type':'application/json'} });
       const emails = toto.data ;
       let maliste =[] ;
       emails.forEach(mail=>mail.snippet?.includes('RGPD DROIT DES PERSONNES') && maliste.push(mail.content?.match(/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g)[0]))

       console.log(maliste)
    }


    // PARTIE GOOGLE MAPS AUTOCOMPLETE
    const [inputValue, setInputValue] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showList, setShowList] = useState(false);

  // Fonction utilitaire pour extraire les données d'adresse
  const extractAddress = (place) => {
    const components = place.addressComponents || [];
    const result = { streetNumber: '', street: '', zip: '', city: '', full: place.formattedAddress };
    
    components.forEach(c => {
      const types = c.types;
      if (types.includes("street_number")) result.streetNumber = c.longText;
      if (types.includes("route")) result.street = c.longText;
      if (types.includes("postal_code")) result.zip = c.longText;
      if (types.includes("locality")) result.city = c.longText;
    });
    return result;
  };

  const handleInputChange = async (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.length > 2) {
      try {
        // Import direct via la méthode globale de Google Maps 2026
        const google = window.google;
        const { AutocompleteSuggestion } = await google.maps.importLibrary("places");
        
        const { suggestions } = await AutocompleteSuggestion.fetchAutocompleteSuggestions({
          input: value,
          includedRegionCodes: ["FR", "GP", "GF", "MQ", "RE"] // Limitation 5 pays
        });

        setSuggestions(suggestions);
        setShowList(true);
      } catch (error) {
        console.error("Erreur Google Maps:", error);
      }
    } else {
      setSuggestions([]);
      setShowList(false);
    }
  };

  const handleSelect = async (suggestion) => {
    const prediction = suggestion.placePrediction;
    setInputValue(prediction.text.text);
    setShowList(false);

    // Transformation en objet Place et récupération des détails
    const placeObj = prediction.toPlace();
    await placeObj.fetchFields({
      fields: ["addressComponents", "formattedAddress"]
    });

    const detailedAddress = extractAddress(placeObj);
    console.log("Détails de l'adresse sélectionnée :", detailedAddress);
  };
        return(<div className="ecrandevff">
                  <h1>DEV2</h1>
                  <div>
                    <button onClick={handleButtonClick}>
                    {isRecording ? "Arrêter et envoyer" : "Démarrer l'enregistrement"}
                    </button>
                
                  </div>
                  <h2>Mails CTO</h2>
                  <button onClick={findmails}>Click</button>

                  <br/>

                  <h2>Nouveau google maps</h2>

                  <gmp-place-autocomplete
                      id="autocomplete"
                      className="autocomplete"
                      //  style="width: 100%;"
                      componentRestrictions='{"country": ["fr"]}'
                      placeholder="Recherchez une adresse">
              
                  </gmp-place-autocomplete>
            
    <div className="autocomplete-wrapper" style={{ position: 'relative' }}>
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder="Entrez votre adresse"
        className="mon-input-perso"
      />

      {showList && suggestions.length > 0 && (
        <ul className="ma-liste-suggestions" style={{
          position: 'absolute', top: '100%', left: 0, right: 0,
          background: 'white', border: '1px solid #ccc', zIndex: 1000,
          listStyle: 'none', padding: 0, margin: 0
        }}>
          {suggestions.map((s, index) => (
            <li 
              key={index}
              onClick={() => handleSelect(s)}
              style={{ padding: '10px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
            >
              {s.placePrediction.text.text}
            </li>
          ))}
        </ul>
      )}
    </div>



                </div>)
}

export default EcranDev2 ;

